import { useScrollToTop } from "../../Utility";

export default function UserGuide() {
  // * At the top of the page.
  useScrollToTop();

  return (
    <>
      <div className=" h-[100vh] px-6 inline-flex justify-center items-center">
        <h4 className=" text-center text-lg ">
          <b> User Guide Coming Soon! </b> Stay tuned for the release of our
          comprehensive User Guide, packed with setup instructions, usage
          guidelines, troubleshooting tips, and more. We appreciate your
          patience and look forward to providing you with all the essential
          information to enhance your experience with our product. For immediate
          assistance,
          <a href="mailto:jsononclouds@gmail.com">
            <span className="text-Brand-Color"> Email us</span>
          </a>{" "}
          .Thank you for choosing our product!
        </h4>
      </div>
    </>
  );
}

// export default function userGuide() {
//   return (

//   );
// }
